import { TaxonomyLensSourceDescription } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/source-description';
import { TaxonomyLensSourceTooltipContent } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/source-description/tooltip';
import { KBUrl, TooltipReadMoreKbLink } from '@upright/ui/common/upright/kb-urls';

export const taxonomyLensTexts = {
  SourceDescription: TaxonomyLensSourceDescription,
  SourceTooltipContent: TaxonomyLensSourceTooltipContent,
  LensTitle: () => <>EU taxonomy</>,
  LensDescription: () => <>Alignment with the EU taxonomy</>,
  LensTooltipContent: () => (
    <>
      Alignment with the EU taxonomy for sustainable activities, represented with both eligibility and alignment
      indicators.
      <TooltipReadMoreKbLink href={KBUrl.METRICS_TAXONOMY} />
    </>
  ),
};
